// BackToTop.js - Updated with professional features
import React, { useState, useEffect } from "react";
import "./BackToTop.css";

const BackToTop = () => {
    const [visible, setVisible] = useState(false);
    const [scrollProgress, setScrollProgress] = useState(0);
    const [hovered, setHovered] = useState(false);

    // Show button after user scrolls down 300px and track scroll progress
    useEffect(() => {
        const handleScroll = () => {
            const scrolled = window.pageYOffset;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;

            // Calculate scroll progress percentage
            const progress = (scrolled / (documentHeight - windowHeight)) * 100;
            setScrollProgress(Math.min(progress, 100));

            // Show button after scrolling 300px
            setVisible(scrolled > 300);
        };

        // Add scroll event listener
        window.addEventListener("scroll", handleScroll);

        // Initial call
        handleScroll();

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });

        // Optional: Add click feedback animation
        const button = document.querySelector('.back-to-top');
        if (button) {
            button.style.transform = 'scale(0.95)';
            setTimeout(() => {
                button.style.transform = '';
            }, 200);
        }
    };

    // Calculate scroll indicator style
    const scrollIndicatorStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: `${scrollProgress}%`,
        background: 'rgba(245, 209, 104, 0.3)', // Accent Gold with opacity
        borderRadius: '50px',
        zIndex: -1,
        transition: 'height 0.2s ease'
    };

    return (
        visible && (
            <button
                className="back-to-top"
                onClick={scrollToTop}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                aria-label="Scroll to top of page"
                title="Back to Top"
            >
                {/* Scroll progress indicator */}
                <div style={scrollIndicatorStyle}></div>

                {/* Animated arrow with text */}
                <span className="back-to-top-content">
                    {hovered ? (
                        <>
                            <span className="back-to-top-text">Back to Top</span>
                            <span className="back-to-top-arrow">↑</span>
                        </>
                    ) : (
                        <span className="back-to-top-arrow">↑</span>
                    )}
                </span>
            </button>
        )
    );
};

export default BackToTop;